import { useEffect, useState } from "react";
import TabSettings from 'components/__new/common/TabSettings';
import useEmployerProducts from 'hooks/useEmployerProducts';
import useLoginInfo from "hooks/useLoginInfo";


const SettingsTab = () => {
    const {userInfo} = useLoginInfo();
    const { isOnDemandUser, isPayrollUser } = useEmployerProducts();
    const [options, setOptions] = useState([]);
    
    
    useEffect(() => {
        const data = [
            {
                title: <span>Profile</span>,
                type: "link",
                url: "/settings/profile",
            },
            {
                title: <span>Company Details</span>,
                type: "link",
                url: "/settings/info",
            },
        ]
        
        if (userInfo?.employer?.accountType !== "sub"){
            data.push({
                title: <span>Team Management</span>,
                type: "link",
                url: "/settings/administrators",
            })
            data.push({
                title: <span>Team Management (NEW)</span>,
                type: "link",
                url: "/settings/team-management",
            },)
        }
        
        if (isOnDemandUser || isPayrollUser){
            data.push({
                title: <span>Preferences</span>,
                type: "link",
                url: "/settings/preferences",
            })
        }
        
        data.push({
            title: <span>Approval Workflows</span>,
            type: "link",
            url: "/settings/approvals",
        },)
        
        setOptions(data);
        // eslint-disable-next-line
    }, [])
    
    
    return ( 
        <TabSettings options={options} />
    )
}


export default SettingsTab;